import React from 'react';
import { bool, number, func } from 'prop-types';
import { noop } from 'lodash';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Checkbox } from '@fiverr-private/fit';
import withImpressions from '../../hoc/withImpressions';
import ProClientIcon from '../../ProClient/ProClientIcon';
import { BUSINESS_FILTER_CLASS, IMPRESSION_CONFIG } from './constants';

import '../style.scss';

const validate = ({ filterCount = 0 }) => filterCount > 0;

const Business = ({ businessChecked = false, filterCount = 0, onToggle = noop }) => {
    if (!validate({ filterCount })) {
        return null;
    }

    return (
        <div className={classNames(BUSINESS_FILTER_CLASS, 'toggle-filter col-12-xs')}>
            <Checkbox id="business-filter" checked={businessChecked} onChange={onToggle}>
                <label className="flex flex-items-center toggle-filter-text" htmlFor="business-filter">
                    <ProClientIcon className="m-r-4" />
                    <I18n k="reviews.filters.pro_client" params={{ filterCount }} />
                </label>
            </Checkbox>
        </div>
    );
};

Business.propTypes = {
    businessChecked: bool,
    filterCount: number,
    onToggle: func,
};

export default withImpressions(Business, IMPRESSION_CONFIG);
